module.exports = __webpack_public_path__ + "static/media/hr icon 1.3475de17.png";